import { Outlet } from "react-router-dom";
import { IndexPageHeaderWithMerge } from "./IndexPageHeaderWithMerge";
import { CommonMergeModel } from "../../entities/common";
import { memo } from "react";

interface DefaultIndexWithMergeProps {
  title: string;
  query: Function;
  mergeMutation: Function;
  merger: (mergerCallback: (data: CommonMergeModel) => Promise<boolean>) => JSX.Element;
}

const DefaultIndexWithMerge = memo(({ title, query, mergeMutation, merger }: DefaultIndexWithMergeProps) => {
  return (
    <div>
      <IndexPageHeaderWithMerge title={title} query={query} mergeMutation={mergeMutation} merger={merger} />
      <div className="mt-4">
        <Outlet />
      </div>
    </div>
  );
});

export const GetDefaultIndexWithMerge =
  ({ title, query, mergeMutation, merger }: DefaultIndexWithMergeProps) =>
  () =>
    <DefaultIndexWithMerge title={title} query={query} mergeMutation={mergeMutation} merger={merger} />;
